import { AfterViewInit, Component, ChangeDetectorRef, inject } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { isCreditContract } from '../../../../utils/contract-utils';
import { ContractCP } from '../../../../models/contract-model';

@Component({
    standalone: false,
    selector: 'por-contract-detail-amount-due-renderer-component',
    templateUrl: './amount-due-cell-renderer.component.html'
})
export class PorContactDetailAmountDUeRendererComponent implements ICellRendererAngularComp, AfterViewInit {
    private readonly cdref = inject(ChangeDetectorRef);

    public cellValue!: string;
    contractId!: string;
    public params!: ICellRendererParams;
    isNotClickable = false;

    ngAfterViewInit(): void {
        this.cdref.detectChanges();
    }
    // gets called once before the renderer is used
    agInit(params: ICellRendererParams): void {
        this.cellValue = this.getValueToDisplay(params);
        this.params = params;
        this.contractId = params.data?.contractId;
        const contract: ContractCP = params.data as ContractCP;
        if (contract.paymentPending || isCreditContract(contract) || this.params.context?.componentParent.payMultipleClicked()) {
            this.isNotClickable = true;
        }
    }

    // gets called whenever the user gets the cell to refresh
    refresh(params: ICellRendererParams) {
        // set value into cell again
        this.cellValue = this.getValueToDisplay(params);
        return true;
    }

    loadContractDetail() {
        this.params.context?.componentParent.amountDueClicked.set(true);
        this.params.context?.componentParent.loadContractDetailModal(this.contractId);
    }

    getValueToDisplay(params: ICellRendererParams) {
        return params.valueFormatted ? params.valueFormatted : params.value;
    }
}
